import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlidePartners, PartnersFormData, PartnersApiData } from './types'

export const usePartnersUpdate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isUpdating, setIsUpdating] = useState(false)

  const updatePartners = async (
    id: string,
    formData: PartnersApiData,
    setSlidePartners: (slidePartners: SlidePartners) => void,
    resetForm: (data: PartnersFormData) => void
  ) => {
    if (!id) return

    setIsUpdating(true)

    try {
      const response = await apiClient.business.slidePartnersUpdateUpdate({
        businessIdeaId: id,
        partners: formData.partners,
      })

      if (response.data?.partners) {
        setSlidePartners(response.data.partners)
        showSnackBar(['オススメ共創パートナー企業を更新しました'], 'success')

        try {
          resetForm({
            partners: JSON.parse(response.data.partners.partners || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['オススメ共創パートナー企業のデータの読み込みに失敗しました。'], 'error')
        }
      }
    } catch (e) {
      console.error('オススメ共創パートナー企業の更新に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updatePartners,
  }
}
